<!-- eslint-disable max-len -->
<template>
  <div>
    <FactSheet :entity-external-id="entityExternalId" />
  </div>
</template>

<script>
import FactSheet from '@frontend/ui/features/fact-sheet/FactSheet.vue';

export default {
  name: 'FactSheetView',
  components: {
    FactSheet,
  },
  data() {
    return {
      entityExternalId: '',
    };
  },
  created() {
    this.entityExternalId = this.$route.params.entityExternalId;
  },
};
</script>
